"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TimezoneTypes = _interopRequireDefault(require("../constants/TimezoneTypes"));

var _I18n = _interopRequireDefault(require("I18n"));

var _default = _react.default.createClass({
  displayName: "FormattedRelative",
  propTypes: {
    includeSuffix: _react.PropTypes.bool,
    type: _react.PropTypes.oneOf([_TimezoneTypes.default.PORTAL, _TimezoneTypes.default.USER, _TimezoneTypes.default.UTC]),
    value: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.number]).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      includeSuffix: true,
      type: _TimezoneTypes.default.PORTAL
    };
  },
  render: function render() {
    var _this$props = this.props,
        value = _this$props.value,
        type = _this$props.type,
        includeSuffix = _this$props.includeSuffix;
    return _react.default.createElement("span", null, _I18n.default.moment[type](value).fromNow(!includeSuffix));
  }
});

exports.default = _default;
module.exports = exports.default;